export default __webpack_public_path__ + "static/media/Logo_Vaudoise_Assurances.dbada178.svg";